// import {
//   HttpPost
// } from "../lib/login.request"
import {
  HttpPost2,
  HttpPost,
  HttpGet2,
} from "../lib/api.request"
import {
  randomWord,
  getTimeStamp,
  tempLoginSign,
  loginSign
} from "../lib/sign"
import baseConfig from '../../../public/config.json'

export const reqTempVideo = () => {
  //export const reqTempLogin = function () {
  var randomStr
  var timestamp
  var sign
  var password
  //randomStr = randomWord(true, 6, 8)
  randomStr = randomWord(true, 10, 16)
  timestamp = getTimeStamp()
  password = baseConfig.tempLoginPwd
  sign = tempLoginSign(timestamp, randomStr, password)
  var bodyJson = {
    randstr: randomStr,
    timestamp: timestamp,
    sign: sign
  }
  return new Promise((resolve, reject) => {
    HttpGet2('/api/public/wxgzh/getvideoinfo', bodyJson)
      .then(function (resp) {
        resolve(resp);
      }).catch(function (err) {
        reject(err);
      })
  })
}


// export  {
//   reqLogin,
//   reqTempLogin
// }
